import Navigation from './components/Navigation';
import WidgetArea from './components/WidgetArea';
import './scss/app.scss';

const App = () => {
  return (
      <div className="fiterr-dashboard-wrapper">
        <WidgetArea/>
      </div>
  );
}

export default App;